// @flow

import Vue from 'vue'

import type { AuthenticationClientInterface } from './authentication-client-interface'
import { LoginResult } from '../../types/login-result'
import {
  ROUTE_PATH_API_LOGIN,
  ROUTE_PATH_API_RESET_PASSWORD,
  ROUTE_PATH_API_FORGOT_PASSWORD,
  ROUTE_PATH_API_VERIFY_TOKEN
} from '../../../src-server/api-routes'
import AbstractAuthenticatedClient from '../abstract-authenticated-client'

class AuthenticationClient implements AuthenticationClientInterface {
  options: {}

  constructor () {
    this.options = {
      responseType: 'json',
      timeout: 5000,
      withCredentials: true
    }
  }

  async login (username: string, password: string): Promise<LoginResult> {
    try {
      const response = await Vue.$http.post(`/api${ROUTE_PATH_API_LOGIN}`, {username, password}, this.options)
      return response.data
    } catch (error) {
      throw AbstractAuthenticatedClient.convertError(error)
    }
  }

  async forgotPassword (email: string, returnUrl: string): Promise<boolean> {
    try {
      await Vue.$http.post(`/api${ROUTE_PATH_API_FORGOT_PASSWORD}`, {email, basePasswordResetUrl: returnUrl}, this.options)
      return true
    } catch (error) {
      throw AbstractAuthenticatedClient.convertError(error)
    }
  }

  async verifyResetPasswordToken (token: string): Promise<boolean> {
    try {
      await Vue.$http.head(`/api${ROUTE_PATH_API_VERIFY_TOKEN}/${token}`, this.options)
      return true
    } catch (error) {
      throw AbstractAuthenticatedClient.convertError(error)
    }
  }

  async resetPassword (token: string, password: string): Promise<boolean> {
    try {
      await Vue.$http.patch(`/api${ROUTE_PATH_API_RESET_PASSWORD}/${token}`, {password}, this.options)
      return true
    } catch (error) {
      throw AbstractAuthenticatedClient.convertError(error)
    }
  }
}

export default AuthenticationClient



// WEBPACK FOOTER //
// ./src/services/authentication/authentication-client.js